import React, { useEffect, useRef, useState } from 'react'
import { Accordion } from 'react-bootstrap'
import AccordionItems from './AccordionItems';
import ActivityValiditySection from './partial/ActivityValiditySection';
import NonOperatingDateTimeSection from './partial/NonOperatingDateTimeSection';
import BookingCutOffSection from './partial/BookingCutOffSection';
import ActivitySlotSection from './partial/ActivitySlotSection';
import ActivityPricingSection from './partial/ActivityPricingSection';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import CancellationPolicySection from './partial/CancellationPolicySection';
import { getactivitymanagebyid, priceCalculation } from '../../ActivitymasterUtility';


const ActivityPricing = ({
    disabled,
    PricingTab,
    setPricingTab,
    ActivityName,
    dropdownData,
    editDisabled,
    setEditDisabled,
    ActivityManagePricingId,
    ActivityBasicInfoId,
    setActivityManagePricingId,
}) => {

    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState(null);

    const AccordionItemKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
    const [activeKeys, setActiveKeys] = useState(AccordionItemKeys);

    const ActivityValiditySectionRef = useRef(null);
    const NonOperatingDateTimeSectionRef = useRef(null);
    const BookingCutOffSectionRef = useRef(null);
    const ActivitySlotSectionRef = useRef(null);
    const ActivityPricingSectionRef = useRef(null);
    const CancellationPolicySectionRef = useRef(null);

    const [ActivityValidityForm, setActivityValidityForm] = useState({
        ValidityFromDate: null,
        ValidityToDate: null,
    })

    const [NonOperatingDateTimeForm, setNonOperatingDateTimeForm] = useState({
        IsNonOperatingDates: false,
        NonOperatingFromDate: null,
        NonOperatingToDate: null,
        NonOperatingTime: "00:00:00"
    })

    const [BookingCutOffForm, setBookingCutOffForm] = useState({
        BookingCutoffDays: null,
        BookingCutoffTime: "00:00:00"
    })

    const defaultActivitySlotForm = {
        SeqNo: 0,
        StartTime: "00:00:00",
        EndTime: "00:00:00",
        OperatedDayId: [],
        activityManageActivitySlotId: 0
    }

    const [NonOperatingDateList, setNonOperatingDateList] = useState({
        NonOperatingDay: []
    });
    const [isActivitySlotEdit, setIsActivitySlotEdit] = useState(false);
    const [ActivitySlotsForm, setActivitySlotsForm] = useState(defaultActivitySlotForm);
    const [IsScheduleActivity, setIsScheduleActivity] = useState(false);
    const [ActivityManageSlots, setActivityManageSlots] = useState([]);

    const [PricingForm, setPricingForm] = useState({
        PricingTypeId: 0,
        ActivityManagePaxTypeId: 0,
        // IsUnitPricing: false,
        IsGroupCapacity: true,
        // MaximumPersonCapacity: null,
    })

    const defaultUserPricing = {
        ActivityManageTaxId: 0,
        BasePrice: null,
        Commission: null,
        ETMMarkup: null
    }

    const [UserPricingForm, setUserPricingForm] = useState({
        adult: defaultUserPricing,
        child: defaultUserPricing,
        Group: defaultUserPricing,
    })

    useEffect(() => {
        console.log(UserPricingForm, 'UserPricingForm')
    }, [UserPricingForm])

    const defaultPersonPricingForm = {
        BasePrice: null,
        ActivityManageTaxId: 0,
        Commission: null,
        CommissionAmount: null,
        ETMMarkup: null,
        NetPrice: null,
        NetMarkupAmount: null,
        MarkupTax: null,
        DisplayPrice: null,
    }

    const defaultUnitPricingForm = {
        UnitBasePrice: null,
        UnitActivityManageTaxId: 0,
        UnitCommission: null,
        UnitCommissionAmount: null,
        UnitETMMarkup: null,
        UnitNetPrice: null,
        UnitNetMarkupAmount: null,
        UnitMarkupTax: null,
        UnitDisplayPrice: null,
    }

    const [AdultPricingForm, setAdultPricingForm] = useState({
        ActivityManagePaxTypeId: 1,
        ...defaultPersonPricingForm
    })
    const [ChildPricingForm, setChildPricingForm] = useState({
        ActivityManagePaxTypeId: 2,
        ...defaultPersonPricingForm
    })
    const [UnitPricingForm, setUnitPricingForm] = useState(defaultUnitPricingForm);

    const [ActivityCancellationPolicy, setActivityCancellationPolicy] = useState({
        ActivityManagePolicyTypeId: 0,
        ActivityManageCurrentStatusId: 0,
        NoShow: null,
        UpTo24Hrs: null,
        UpTo48Hrs: null,
        MoreThan48Hrs: null
    })

    const retrieveAPI = async (ActivityManageId) => {
        const retrieveData = await getactivitymanagebyid(ActivityManageId, dropdownData?.cityList);
        console.log(retrieveData, 'retrieveData')
        retrieveData && setPricingTab(retrieveData?.PricingTab);
    }

    useEffect(() => {
        if (PricingTab) {
            console.log(PricingTab, 'PricingTab')
            const { ActivityValidity, NonOperatingDateTime, NonOperatingDays, BookingCutOff, IsScheduleActivity, ActivityManageSlots, PricingForm, UserPricingForm, ActivityCancellationPolicy } = PricingTab;
            setActivityValidityForm(ActivityValidity);
            setNonOperatingDateTimeForm(NonOperatingDateTime);
            setBookingCutOffForm(BookingCutOff);
            setIsScheduleActivity(IsScheduleActivity);
            setActivityManageSlots(ActivityManageSlots);
            setPricingForm(PricingForm);

            const adult = priceCalculation(
                dropdownData?.taxList,
                UserPricingForm?.adult?.ActivityManagePaxTypeId ?? null,
                PricingForm?.PricingTypeId,
                UserPricingForm?.adult?.BasePrice ?? null,
                UserPricingForm?.adult?.ActivityManageTaxId || 0,
                UserPricingForm?.adult?.Commission ?? null,
                UserPricingForm?.adult?.ETMMarkup ?? null
            )

            const child = priceCalculation(
                dropdownData?.taxList,
                UserPricingForm?.child?.ActivityManagePaxTypeId ?? null,
                PricingForm?.PricingTypeId,
                UserPricingForm?.child?.BasePrice ?? null,
                UserPricingForm?.child?.ActivityManageTaxId || 0,
                UserPricingForm?.child?.Commission ?? null,
                UserPricingForm?.child?.ETMMarkup ?? null
            )

            const Group = priceCalculation(
                dropdownData?.taxList,
                UserPricingForm?.Group?.ActivityManagePaxTypeId ?? null,
                PricingForm?.PricingTypeId,
                UserPricingForm?.Group?.BasePrice ?? null,
                UserPricingForm?.Group?.ActivityManageTaxId || 0,
                UserPricingForm?.Group?.Commission ?? null,
                UserPricingForm?.Group?.ETMMarkup ?? null
            )

            setUserPricingForm((prev) => ({ ...prev, adult, child, Group: { ...Group, MaximumPersonCapacity: UserPricingForm?.Group?.MaximumPersonCapacity } }));
            setActivityCancellationPolicy(ActivityCancellationPolicy);
            setNonOperatingDateList(NonOperatingDays)
        }
    }, [PricingTab])

    const validation = () => {
        let status = true;

        const ActivityValidityErrors = ActivityValiditySectionRef?.current?.canValidate
            && typeof ActivityValiditySectionRef?.current?.ValidateActivityValidityForm === "function" ?
            ActivityValiditySectionRef?.current?.ValidateActivityValidityForm() : {};

        const NonOperatingDateTimeErrors = NonOperatingDateTimeSectionRef?.current?.canValidate
            && typeof NonOperatingDateTimeSectionRef?.current?.ValidateNonOperatingDateTimeForm === "function" ?
            NonOperatingDateTimeSectionRef?.current?.ValidateNonOperatingDateTimeForm() : {};

        const BookingCutOffErrors = BookingCutOffSectionRef?.current?.canValidate
            && typeof BookingCutOffSectionRef?.current?.ValidateBookingCutOffForm === "function" ?
            BookingCutOffSectionRef?.current?.ValidateBookingCutOffForm() : {};

        const ActivitySlotsErrors = ActivitySlotSectionRef?.current?.canValidate
            && typeof ActivitySlotSectionRef?.current?.ValidateActivitySlotsForm === "function" ?
            ActivitySlotSectionRef?.current?.ValidateActivitySlotsForm() : {};

        const PricingFormErrors = ActivityPricingSectionRef?.current?.canValidate
            && typeof ActivityPricingSectionRef?.current?.ValidatePricingForm === "function" ?
            ActivityPricingSectionRef?.current?.ValidatePricingForm() : {};

        const CancellationPolicyFormErrors = CancellationPolicySectionRef?.current?.canValidate
            && typeof CancellationPolicySectionRef?.current?.ValidateCancellationPolicyForm === "function" ?
            CancellationPolicySectionRef?.current?.ValidateCancellationPolicyForm() : {};

        let keys = [];
        if (Object.keys(ActivityValidityErrors)?.length > 0) keys.push("1");
        if (Object.keys(NonOperatingDateTimeErrors)?.length > 0) keys.push("2");
        if (Object.keys(BookingCutOffErrors)?.length > 0) keys.push("3");
        if (Object.keys(ActivitySlotsErrors)?.length > 0) keys.push("4");
        if (Object.keys(PricingFormErrors)?.length > 0) keys.push("5");
        if (Object.keys(CancellationPolicyFormErrors)?.length > 0) keys.push("6");

        setActiveKeys(Array.from(new Set([...activeKeys, ...keys])))

        const error = {
            ...ActivityValidityErrors, ...NonOperatingDateTimeErrors, ...BookingCutOffErrors,
            ...ActivitySlotsErrors, ...PricingFormErrors, ...CancellationPolicyFormErrors
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }
        return status;
    }

    const handleSave = async () => {
        let payloadData = {
            ActivityManagePricingId,
            ActivityBasicInfoId,
            ...ActivityValidityForm,
            // ...NonOperatingDateTimeForm,
            IsNonOperatingDates: NonOperatingDateList?.isNonOperatingDates,
            ...BookingCutOffForm,
            IsScheduleActivity, ActivityManageSlots, ...PricingForm,

            ActivityManageNonOperating: NonOperatingDateList?.NonOperatingDay?.length > 0 ? NonOperatingDateList?.NonOperatingDay : [],

            PaxPricedetails: PricingForm.IsGroupCapacity ? [UserPricingForm.Group] :
                PricingForm?.ActivityManagePaxTypeId === 1 ? [{ ...UserPricingForm.adult }] :
                    PricingForm?.ActivityManagePaxTypeId === 2 ? [{ ...UserPricingForm.child }] :
                        PricingForm?.ActivityManagePaxTypeId === 3 ? [{ ...UserPricingForm.adult }, { ...UserPricingForm.child }] : null,
            ActivityCancellationPolicy
        }
        // if (PricingForm?.IsGroupCapacity) {
        //     payloadData = { ...payloadData, ...UnitPricingForm.Group }
        // }

        console.log(payloadData, 'payloadData');

        if (validation()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const userId = user?.userMasterID || 0;
                payloadData = {
                    ...payloadData,
                    UserId: userId
                }

                const insertupdateactivitymanagepricing = await postUsersData('/master/v1/insertupdateactivitymanagepricing', payloadData);
                if (insertupdateactivitymanagepricing?.status) {
                    setActivityManagePricingId(insertupdateactivitymanagepricing?.data);
                    retrieveAPI(ActivityBasicInfoId);
                    dispatch({ type: 'ALERTING', message: insertupdateactivitymanagepricing?.message });
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertupdateactivitymanagepricing?.message });
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }

    }


    const handleClear = () => {
        setFormErrors(null);

        setActivityValidityForm({
            ValidityFromDate: null,
            ValidityToDate: null,
        })

        setNonOperatingDateTimeForm({
            IsNonOperatingDates: false,
            NonOperatingFromDate: null,
            NonOperatingToDate: null,
            NonOperatingTime: "00:00:00"
        })

        setBookingCutOffForm({
            BookingCutoffDays: null,
            BookingCutoffTime: "00:00:00"
        })

        setIsActivitySlotEdit(false);
        setActivitySlotsForm(defaultActivitySlotForm);
        setIsScheduleActivity(false);
        setActivityManageSlots([]);

        setPricingForm({
            PricingTypeId: 0,
            ActivityManagePaxTypeId: 0,
            IsUnitPricing: false,
            // MaximumPersonCapacity: null,
        })
        setUserPricingForm({
            adult: defaultUserPricing,
            child: defaultUserPricing,
            Group: defaultUserPricing,
        })
        setAdultPricingForm({
            ActivityManagePaxTypeId: 1,
            ...defaultPersonPricingForm
        })
        setChildPricingForm({
            ActivityManagePaxTypeId: 2,
            ...defaultPersonPricingForm
        })
        setUnitPricingForm(defaultUnitPricingForm);

        setActivityCancellationPolicy({
            ActivityManagePolicyTypeId: 0,
            ActivityManageCurrentStatusId: 0,
            NoShow: null,
            UpTo24Hrs: null,
            UpTo48Hrs: null,
            MoreThan48Hrs: null
        })
    };

    return (
        <div className="my-5">
            <div className="container-fluid form_border my-2 py-3">

                <Accordion
                    alwaysOpen
                    activeKey={activeKeys}
                    onSelect={(eventKey) => {
                        if (!eventKey) return;
                        setActiveKeys(eventKey);
                    }}
                >

                    {/* Activity Name & Inventory start */}
                    {/* <AccordionItems
                        eventKey="0"
                        titleName="Activity Name & Inventory"
                    >
                        <ActivityNameSection ActivityName={ActivityName} />
                    </AccordionItems> */}
                    {/* Activity Name & Inventory end */}

                    {/* Activity Name, Inventory & Validity start */}
                    <AccordionItems
                        eventKey="1"
                        titleName="Activity Name & Validity"
                    >
                        <ActivityValiditySection
                            ref={ActivityValiditySectionRef}
                            ActivityBasicInfoId={ActivityBasicInfoId}
                            ActivityManagePricingId={ActivityManagePricingId}
                            ActivityName={ActivityName}
                            ActivityValidityForm={ActivityValidityForm}
                            setActivityValidityForm={setActivityValidityForm}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                        />
                    </AccordionItems>
                    {/* Activity Name, Inventory & Validity end */}

                    {/* Non Operating date & Time start */}
                    <AccordionItems
                        eventKey="2"
                        titleName="Non Operating date & Time"
                    >
                        <NonOperatingDateTimeSection
                            ref={NonOperatingDateTimeSectionRef}
                            NonOperatingDateTimeForm={NonOperatingDateTimeForm}
                            IsNonOperatingDates={PricingTab?.NonOperatingDateTime?.IsNonOperatingDates}
                            setNonOperatingDateTimeForm={setNonOperatingDateTimeForm}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                            dropdownData={dropdownData}

                            ActivityValidityForm={ActivityValidityForm}
                            NonOperatingDateList={NonOperatingDateList}
                            setNonOperatingDateList={setNonOperatingDateList}
                        />

                    </AccordionItems>
                    {/* Non Operating date & Time end */}

                    {/* Booking Cutt of time start */}
                    <AccordionItems
                        eventKey="3"
                        titleName="Booking Cutt of time"
                    >
                        <BookingCutOffSection
                            ref={BookingCutOffSectionRef}
                            BookingCutOffForm={BookingCutOffForm}
                            setBookingCutOffForm={setBookingCutOffForm}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                        />

                    </AccordionItems>
                    {/* Booking Cutt of time end */}

                    {/* Activity slots start */}
                    <AccordionItems
                        eventKey="4"
                        titleName="Activity slots"
                    >
                        <ActivitySlotSection
                            ref={ActivitySlotSectionRef}
                            ActivityManagePricingId={ActivityManagePricingId}
                            defaultActivitySlotForm={defaultActivitySlotForm}
                            isActivitySlotEdit={isActivitySlotEdit}
                            setIsActivitySlotEdit={setIsActivitySlotEdit}
                            ActivitySlotsForm={ActivitySlotsForm}
                            setActivitySlotsForm={setActivitySlotsForm}
                            IsScheduleActivity={IsScheduleActivity}
                            setIsScheduleActivity={setIsScheduleActivity}
                            ActivityManageSlots={ActivityManageSlots}
                            setActivityManageSlots={setActivityManageSlots}
                            dropdownData={dropdownData}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                        />

                    </AccordionItems>
                    {/* Activity slots end */}

                    {/* Activity Pricing start */}
                    <AccordionItems
                        eventKey="5"
                        titleName="Pricing"
                    >
                        <ActivityPricingSection
                            ref={ActivityPricingSectionRef}
                            PricingForm={PricingForm}
                            setPricingForm={setPricingForm}
                            defaultUserPricing={defaultUserPricing}
                            UserPricingForm={UserPricingForm}
                            setUserPricingForm={setUserPricingForm}
                            dropdownData={dropdownData}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                        />
                    </AccordionItems>
                    {/* Activity slots end */}

                    {/* Cancellation Policy start */}
                    <AccordionItems
                        eventKey="6"
                        titleName="Cancellation Policy"
                    >

                        <CancellationPolicySection
                            ref={CancellationPolicySectionRef}
                            ActivityCancellationPolicy={ActivityCancellationPolicy}
                            setActivityCancellationPolicy={setActivityCancellationPolicy}
                            dropdownData={dropdownData}
                            disabled={disabled}
                            formErrors={formErrors}
                            setFormErrors={setFormErrors}
                            setEditDisabled={setEditDisabled}
                        />


                    </AccordionItems>
                    {/* Cancellation Policy end */}


                </Accordion>


                <div className="text-center mt-5">
                    <button
                        type="button"
                        className='mx-2 btn btn-primary'
                        disabled={editDisabled}
                        onClick={() => handleSave()}
                    >
                        Submit
                    </button>
                    <button type="button" className='mx-2 btn btn-primary' onClick={() => handleClear()} disabled={disabled} >
                        Clear
                    </button>
                </div>

            </div>
        </div>
    )
}

export default ActivityPricing
